export default __webpack_public_path__ + "static/dentalexam-f0aad02f846effc56019fa26ddec416d.jpg";